import React from 'react';
import { useDispatch } from 'react-redux';
import BottomDrawer from '../../../../components/BottomDrawer/BottomDrawer';
import {
  useModalMethods,
  useModalWatch,
} from '../../shared/packages/modalManager';
import { modalNames } from '../../shared/configs/modal';
import Header from './components/Header';
import GridLayout from '../../shared/ui/GridLayout';
import ClientsCard from './components/ClientsCard';
import RecordsCard from './components/RecordsCard';
import CommentsCard from './components/CommentsCard';
import AttachmentsCard from './components/AttachmentsCard';
import { useSearchParamsMethods } from '../../shared/packages/searchParamsManager';
import { searchParamKeys } from '../../shared/configs/searchParams';
import { actionCreators, sliceKeys } from '../../model';
import styles from './index.module.scss';

const { filterReset } = actionCreators[sliceKeys.attachmentsFilter];

const drawerName = modalNames.roomInfoDrawer;

const RoomInfoDrawer = ({ children }) => {
  const { isOpen, props: { room } = {} } = useModalWatch({
    name: drawerName,
  });

  const { closeAndKeepProps, removeProps } = useModalMethods();

  const { setParams } = useSearchParamsMethods();

  const dispatch = useDispatch();

  const handleClose = () => {
    setParams({ [searchParamKeys.detailedInfoRoomId]: undefined });
    closeAndKeepProps(drawerName);
  };

  const afterVisibleChange = (visible) => {
    if (!visible) {
      removeProps(drawerName);
      dispatch(filterReset());
    }
  };

  return (
    <BottomDrawer
      visible={isOpen}
      onClose={handleClose}
      afterVisibleChange={afterVisibleChange}
      maskClosable={false}
    >
      <div className={styles.content}>
        {Boolean(room) && (
          <>
            <Header room={room} />
            <GridLayout adaptive>
              <ClientsCard room={room} />
              <RecordsCard room={room} />
              <AttachmentsCard room={room} />
              <CommentsCard room={room} />
            </GridLayout>
          </>
        )}
      </div>
      {children}
    </BottomDrawer>
  );
};

export default RoomInfoDrawer;
